import { render, staticRenderFns } from "./RegisterHeader.vue?vue&type=template&id=dd8e2252&"
import script from "./RegisterHeader.vue?vue&type=script&lang=js&"
export * from "./RegisterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports